import React from 'react';
import Image from 'next/image';

const Thumbnail = ({ tokenId, size }) => {
  const src = `${process.env.NEXT_PUBLIC_GENESIS_THUMBNAIL_BASEURL}${tokenId}.png`;

  return (
    <div>
      <Image
        src={src}
        alt={`Noundle #${tokenId}`}
        width={size}
        height={size}
        unoptimized
      />
      <div>
        <div className="p-1 text-center fw-bold">Noundle #{tokenId}</div>
      </div>
    </div>
  );
};

Thumbnail.defaultProps = {
  size: 200,
};

export default Thumbnail;
